import { Tab, Tabs as MuiTabs, Theme, Stack } from '@mui/material';

import { FC, SyntheticEvent } from 'react';
import { createUseStyles } from 'react-jss';
import { TabPanel as TabPanelType } from './helpers';
import Icon from '../icon';
import Tooltip from '../tooltip';

interface Props {
  panels: TabPanelType[];
  tabIndex: number;
  onTabChange?: (_event: SyntheticEvent, tabIndex: number) => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  tabs: {
    minHeight: 0,
    // F5DS: 28 + the 2px each tab pads on both sides keeps labels 32px apart
    '& .MuiTabs-flexContainer': {
      gap: 28,
    },
    '& .MuiTab-root': {
      minWidth: 0,
      minHeight: 0,
      padding: '0 2px 12px',
      color: theme.palette.darkGray,
      '&:hover, &.Mui-selected': {
        color: theme.palette.primary.main,
      },
    },
  },
}));

const a11yProps = (index: string) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

const TabBar: FC<Props> = ({ panels, tabIndex, onTabChange }) => {
  const styles = useStyles();

  return (
    <MuiTabs value={tabIndex} onChange={onTabChange} className={styles.tabs}>
      {panels.map(({ label, path, disabled, icon, tooltip }) => {
        const tabEl = (
          <Tab
            key={path}
            label={
              icon ? (
                <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={1}>
                  <Icon name={icon} size="small" /> {label}
                </Stack>
              ) : (
                label
              )
            }
            {...a11yProps(path)}
            disabled={disabled}
            disableRipple
          />
        );

        return tooltip ? (
          <Tooltip title={tooltip} placement="bottom" key={`${path}-tooltip`}>
            {tabEl}
          </Tooltip>
        ) : (
          tabEl
        );
      })}
    </MuiTabs>
  );
};

export default TabBar;
